import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/src/lib/shadcn-utils";

const themePillVariants = cva("inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-foreground", {
  variants: {
    theme: {
      success: "bg-success/20",
      destructive: "bg-destructive/20",
      warn: "bg-warn/20",
      muted: "bg-muted text-muted-foreground",
    },
  },
  defaultVariants: {
    theme: "muted",
  },
});

export interface ThemePillProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof themePillVariants> {}

export function ThemePill({ className, theme, ...props }: ThemePillProps) {
  return <span className={cn(themePillVariants({ theme }), className)} {...props} />;
}
